export enum TabType {
  filters = "filters",
  ticketInfo = "ticketInfo",
}
